import React from "react";

import SearchInput from "../common/SearchInput";

const customerFilters = [
  <SearchInput
    label="common.search"
    source="q"
    alwaysOn
    resettable
    autoFocus
  />,
];

export default customerFilters;
